import { Action, createReducer, on } from '@ngrx/store';

import { CurrentUser } from '@priva/auth/current-user';

import { AppState } from 'app/state/app.state';

import { CurrentUserActions } from '.';

export interface CurrentUserState extends AppState {
    currentUserState: UserState;
}

export interface UserState {
    currentUser: CurrentUser;
    error: boolean;
    loading: boolean;
    done: boolean;
}

export const initialUserState: UserState = {
    currentUser: null,
    error: false,
    loading: false,
    done: false,
};

export const initialState: CurrentUserState = {
    currentUserState: initialUserState,
};

// Reducer function
export const _currentUserReducer = createReducer<CurrentUserState>(
    initialState,
    // reducer for load current user
    on(CurrentUserActions.loadCurrentUser, (state): CurrentUserState => {
        return {
            ...state,
            currentUserState: {
                currentUser: null,
                error: false,
                loading: true,
                done: false,
            },
        };
    }),
    on(CurrentUserActions.loadCurrentUserSuccess, (state, action): CurrentUserState => {
        return {
            ...state,
            currentUserState: {
                currentUser: action.currentUser,
                error: false,
                loading: false,
                done: true,
            },
        };
    }),
    on(CurrentUserActions.loadCurrentUserFailure, (state): CurrentUserState => {
        return {
            ...state,
            currentUserState: {
                currentUser: null,
                error: true,
                loading: false,
                done: true,
            },
        };
    }),
);

export function currentUserReducer(state: CurrentUserState | undefined, action: Action) {
    return _currentUserReducer(state, action);
}
